import styles from "./modals.module.scss"
import Image from "next/image"
import HTMLEmptyModal from "../HTMLModalComponent/HTMLEmptyModal"
import SText from "../Text/SText"

const ForDoctorsModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
  return (
    <HTMLEmptyModal isOpened={isOpen} onClose={closeModal} onProceed={() => null} innerModalCSS={styles.doctorModal}>
      <div className={styles.doctorImage}>
        <Image
          width={288}
          height={240}
          src={"/images/modal/doctor_img.webp"}
          alt={"Doktor Bild"}
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "100%",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <SText style={{ width: "330px" }} variant={"body"} color={"green400"}>
          Lassen Sie uns gemeinsam Mehrwerte für Ihre Praxis und die Betroffenen stiften: Kontaktieren Sie uns hierfür
          gerne über die folgende E-Mail Adresse:{" "}
          <a style={{ color: "#1BC8CC" }} href={"mailto:info@skinuvita.de"}>
            info@skinuvita.de
          </a>
        </SText>
      </div>
    </HTMLEmptyModal>
  )
}

export default ForDoctorsModal
